import { isEmpty } from 'lodash';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { getObjectValue } from 'utilities';
import { Cells } from '../../../../../common/types/scalarSpreadsheet';
import { Change } from '../../../../ValuationsAllocation/approaches/ExternalValuation/config/customAfterCellsChanged/types';
import { ExternalValuationCellCustomData } from '../../../../ValuationsAllocation/approaches/ExternalValuation/config/customReverseParser/types';
import createColumnsCalibrationPerformance from '../performance_metrics/config/createColumns/createColumnsCalibrationPerformance';
import { CreateCalibrationOutputsDataParams } from '../performance_metrics/types';
import { getSelectorValues } from '../utilities';
import customCalibrationOutputsAfterCellsChanged from './customCalibrationOutputsAfterCellsChanged';
import parser from './parser';
import reverseParserCalibrationOutputs from './reverseParserCalibrationOutputs';
import getRowConfigCalibrationOutputs from './rowConfigCalibrationOutputs';
import rowTransformerCalibrationOutputs from './rowTransformerCalibrationOutputs';

const createCalibrationOutputsData = (params: CreateCalibrationOutputsDataParams) => {
  const { calibration, approach, name, isDisabled, financials, comparisons } = params;

  const { valuations_approach_gpc: valuationsApproachGpc } = getObjectValue(approach);

  const columnsPerformance = createColumnsCalibrationPerformance({
    valuationsApproachGpc,
    financials,
    gpcComparisonByDate: comparisons,
  });

  const columns = rowTransformerCalibrationOutputs(getSelectorValues(calibration));

  const rowConfig = getRowConfigCalibrationOutputs({
    calibration,
    isDisabled,
    columnsPerformance,
  });

  const afterCellsChanged = (initialChanges: Array<Change>, cells: Cells<ExternalValuationCellCustomData>) =>
    customCalibrationOutputsAfterCellsChanged({
      initialChanges,
      cells,
      columnsPerformance,
      calibration,
    });

  const spreadsheet = !isEmpty(columns)
    ? new SpreadsheetConfig({
      columns,
      name,
      parser,
      rowConfig,
      tableData: { calibration, columnsPerformance, isDisabled },
      totalParser: undefined,
      format: undefined,
      afterCellChanged: afterCellsChanged as unknown as SpreadsheetConfig['afterCellChanged'],
      reverseParser: reverseParserCalibrationOutputs as unknown as SpreadsheetConfig['reverseParser'],
      allowReorderColumns: false as unknown as SpreadsheetConfig['allowReorderColumns'],
      showToolbar: true,
      allowConfirmAndDeleteColumn: false,
      allowCopyColumn: false,
      allowCopyRows: !isDisabled,
      allowAddSingleRow: !isDisabled,
      allowDeleteRow: !isDisabled,
      allowDeleteColumn: false,
      reverseParseAfterLoad: true,
    })
    : undefined;

  return { spreadsheet };
};

export default createCalibrationOutputsData;
